import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/admin/tests/")({
  beforeLoad: () => {
    throw redirect({
      to: "/dashboard/admin/catalog",
      search: { tab: "tests" },
    });
  },
});
